"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _colors = require("HubStyleTokens/colors");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var PageContainer = _styledComponents.default.div.withConfig({
  displayName: "PageContainer",
  componentId: "jbfb0l-0"
})(["background-color:", ";min-height:100vh;"], _colors.OLAF);

var _default = PageContainer;
exports.default = _default;
module.exports = exports.default;